import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import TRANSPORTS from 'shared/data/json/transports.json';
import LocationsBlock from 'desktop/components/LocationsBlock/LocationsBlock';
import { partsFormAsyncSetActions } from 'shared/actions/partsForm';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { sortCollection } from 'shared/helpers/arrays';
import { clearSelected } from 'shared/actions/searchForm';
import s from './StoPanel.css';

let timeout = null;
class DealersPanel extends React.Component {
  static propTypes = {
    selectedActions: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,
    formVocabulary: PropTypes.shape().isRequired,
    dispatch: PropTypes.func.isRequired,
    formData: PropTypes.shape().isRequired,
    partsFormVocabulary: PropTypes.shape(),
    action: PropTypes.shape({ partsFormAsyncSetActions: PropTypes.func }),
    //
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    firms: [],
    action: {},
    partsFormVocabulary: {},
  };
  componentWillUnmount() {
    this.props.dispatch(clearSelected());
  }
  inputChange = data => {
    clearTimeout(timeout);
    timeout = setTimeout(
      () => {
        this.props.action.partsFormAsyncSetActions({ str: data });
      },
      300,
      data,
    );
  };

  handleOfficialToggle = () => {
    const { formState, selectedActions, action } = this.props;
    selectedActions.set.isOfficial(!formState.isOfficial ? 1 : null);
    action.partsFormAsyncSetActions({ count: true });
  };

  render() {
    const {
      formVocabulary,
      formState = {},
      formData,
      selectedActions,
      intl,
      action,
      partsFormVocabulary: { company = [], makes = [], typeWork = [] },
    } = this.props;
    const { categories } = formVocabulary;
    const { models } = formData;

    sortCollection(models, 'title');
    sortCollection(categories, 'title');

    const selectedSetActions = selectedActions.set;
    return (
      <div>
        <div className={s.mainform}>
          <div className={s.filterItemOne}>
            <Select
              placeholder={intl.formatMessage({ id: 'Введите название компании' })}
              instanceId="company-ff"
              name="company"
              options={company}
              labelKey="title"
              valueKey="id"
              disabled={false}
              onInputChange={this.inputChange}
              onChange={a => {
                selectedSetActions.company(a);
                action.partsFormAsyncSetActions({ count: true });
              }}
              value={formState.company}
            />
          </div>
          <div className={s.LocationItem}>
            <LocationsBlock className={s.locationInput} />
          </div>
          <div className={cx(s.filterItem, s.doubleSelects)}>
            <div className={cx(s.doubleItem, s.doubleFirstItem)}>
              <Select
                placeholder={intl.formatMessage({ id: 'Транспорт' })}
                instanceId="transport-ff"
                name="transport"
                options={TRANSPORTS}
                labelKey="title"
                valueKey="id"
                disabled={false}
                onChange={a => {
                  selectedSetActions.transport(a);
                  action.partsFormTransportSetActions(a);
                  action.partsFormAsyncSetActions({ count: true });
                }}
                value={formState.transport}
              />
            </div>
            <div className={s.doubleItem}>
              <Select
                placeholder={intl.formatMessage({ id: 'Марка' })}
                instanceId="makes-ff"
                name="makes"
                options={makes}
                labelKey="title"
                valueKey="id"
                disabled={false}
                onChange={a => {
                  selectedSetActions.makes(a);
                  action.partsFormAsyncSetActions({ count: true });
                }}
                value={formState.makes}
              />
            </div>
          </div>
          <div className={s.filterItem}>
            <Select
              placeholder={intl.formatMessage({ id: 'Тип работ' })}
              instanceId="typeWork-ff"
              name="typeWork"
              options={typeWork}
              labelKey="title"
              valueKey="id"
              disabled={false}
              onChange={a => {
                selectedSetActions.typeWork(a);
                action.partsFormAsyncSetActions({ count: true });
              }}
              value={formState.typeWork}
            />
          </div>
          <div className={s.filterItem}>
            <div className={s.checkboxContainer}>
              <label className={s.checkbox}>
                <input
                  type="checkbox"
                  onChange={this.handleOfficialToggle}
                  checked={!!formState.isOfficial}
                />{' '}
                <FormattedMessage id="Только официальные" />
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => ({
  action: bindActionCreators(
    {
      partsFormAsyncSetActions: partsFormAsyncSetActions.company,
      partsFormTransportSetActions: partsFormAsyncSetActions.transport,
    },
    dispatch,
  ),
  dispatch,
});
export default withStyles(s)(connect(null, mapDispatchToProps)(injectIntl(DealersPanel)));



// WEBPACK FOOTER //
// ./src/desktop/components/SearchPanel/StoPanel/StoPanel.js